import React, { useContext, useState } from "react";
import style from "./index.module.scss";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import CourseButton from "components/CourseComponents/CourseButton";
import useModalHandler from "utils/useModalHandler";
import { CourseContext } from "../Store";
import { Spin } from "antd";
import ListItem from "./components/ListItem";
import ExerciseModal from "./components/ExerciseModal";
import useRequest from "utils/useRequest";
import { getExerciseList } from "service/exercise";
import qs from "qs";
import { useHistory } from "react-router-dom";

export default function Exercise() {
    const history = useHistory();

    const modal = useModalHandler();
    const { basename, course } = useContext(CourseContext);
    const weekTimeId = course.weekTimeId;
    const [data, { loading }, doFn] = useRequest(
        () => getExerciseList(weekTimeId),
        {},
        [weekTimeId]
    );
    const [visible, setVisible] = useState(false);

    function onClick() {
        setVisible(true);
        modal.open();
    }

    async function onOk() {
        await doFn();
        setVisible(false);
    }

    function onCancel() {
        modal.close();
        setVisible(false);
    }

    function gotoDetail(exerciseId: number, params?: StringMap) {
        const query = params ? `?${qs.stringify(params)}` : "";
        history.push(`${basename}/exercise/students/${exerciseId}${query}`);
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    练习活动（{data?.length || 0}）
                </div>

                <CourseButton type="add" onClick={onClick}>
                    添加
                </CourseButton>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem
                        key={item.id}
                        item={item}
                        updateList={doFn}
                        gotoDetail={gotoDetail}
                    />
                ))}
                {data && data.length < 1 && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>

            {visible && (
                <ExerciseModal
                    type="create"
                    visible={modal.visible}
                    onOk={onOk}
                    onCancel={onCancel}
                />
            )}
        </div>
    );
}
